/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Vuex from "vuex";

import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import discount from "./modules/setup/discount";
import authModule from "./modules/auth";
import dashboardModule from "./modules/dashboard/index";
import entityModule from "./modules/entity";
import chargecodeModule from "./modules/setup/chargecode";
import transactionModule from "./modules/transaction";
import customerModule from "./modules/customer";
import leadsModule from "./modules/leads";
import reportsModule from "./modules/reports";
import inventoryModule from "./modules/inventory";
import ticket from "./modules/Tickets";
import taxmap from "./modules/setup/taxmap";
import items from "./modules/setup/items";
import contractPeriod from "./modules/setup/contractPeriod";
import itemModel from "./modules/setup/itemModel";
import serviceProducts from "./modules/setup/serviceProducts";
import broadcaster from "./modules/setup/broadcaster";
import planPrice from "./modules/setup/planPrice";
import admin from "./modules/admin";
import discountPromotion from "./modules/setup/discountPromotion";
import priceRegion from "./modules/setup/priceRegion";
import catalogueMapping from "./modules/setup/catalogueMapping";
import teams from "./modules/setup/teams";
import addressMaster from "./modules/setup/addressMaster";
import feeMaster from "./modules/setup/feeMaster";
import usageRating from "./modules/setup/usageRating";
import priorityMapping from "./modules/setup/priorityMapping";
import teamMapping from "./modules/setup/teamMapping";
import collectionProfile from "./modules/setup/collectionProfile";
import ipManagement from "./modules/setup/ipManagement";
import closedUserGroup from "./modules/setup/closedUserGroup";
import zoneSetup from "./modules/setup/zoneSetup";
import supplier from "./modules/setup/supplier";
import vendorManagement from "./modules/setup/vendorManagement";
import voucherPin from "./modules/setup/voucherPin";
import users from "./modules/system/users";
import manageRoles from "./modules/system/manageRoles";
import currencyMaster from "./modules/system/currencyMaster";
import currencyExchange from "./modules/system/currencyExchange";
import configuration from "./modules/system/configuration";
import provisioningConfig from "./modules/system/provisioningConfig";
import manageReport from "./modules/system/manageReport";
import qna from "./modules/system/qna";
import shiftManagement from "./modules/system/shiftManagement";
import holidayManagement from "./modules/system/holidayManagement";
import messageTemplate from "./modules/system/messageTemplate";
import settings from "./modules/settings";
import manageCodes from "./modules/system/manageCodes";
import customerAccount from "./modules/customer/account";
import customerTicket from "./modules/customer/ticket";
import customerService from "./modules/customer/service";
import customerOrder from "./modules/customer/order";
import customerPayment from "./modules/customer/payment";
import customerBillprofile from "./modules/customer/billprofile";
import customerActivation from "./modules/customer/activation";
import customerActivityLog from "./modules/customer/activityLog";
import customerMoreInfo from "./modules/customer/more-info";
import customerOnDemand from "./modules/customer/onDemand";
import mediaDetails from "./modules/setup/mediaDetails";
import propertyDefinition from "./modules/setup/propertyDefinition";
import accounting from "./modules/accounting";
import planValidationRules from "./modules/setup/planValidationRules";
import billManagement from "./modules/bill-management";
import customerActivationNew from "./modules/customer/customerActivation";
import automationMaster from "./modules/setup/automationMaster";
import groupTicketing from "./modules/setup/groupTicketing";

/* global process */
const debug = process.env.NODE_ENV !== "production";
Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    auth: authModule,
    dashboard: dashboardModule,
    entity: entityModule,
    chargecode: chargecodeModule,
    transaction: transactionModule,
    customer: customerModule,
    leads: leadsModule,
    reports: reportsModule,
    inventory: inventoryModule,
    ticket,
    taxmap,
    items,
    contractPeriod,
    itemModel,
    serviceProducts,
    broadcaster,
    planPrice,
    admin,
    discountPromotion,
    priceRegion,
    catalogueMapping,
    discount,
    teams,
    addressMaster,
    feeMaster,
    usageRating,
    priorityMapping,
    teamMapping,
    collectionProfile,
    ipManagement,
    closedUserGroup,
    zoneSetup,
    supplier,
    vendorManagement,
    voucherPin,
    users,
    manageRoles,
    currencyMaster,
    currencyExchange,
    configuration,
    provisioningConfig,
    manageReport,
    qna,
    shiftManagement,
    holidayManagement,
    settings,
    manageCodes,
    customerAccount,
    customerTicket,
    customerService,
    customerOrder,
    customerPayment,
    customerBillprofile,
    customerActivation,
    customerActivityLog,
    customerMoreInfo,
    customerOnDemand,
    messageTemplate,
    mediaDetails,
    propertyDefinition,
    accounting,
    customerActivationNew,
    automationMaster,
    billManagement,
    planValidationRules,
    groupTicketing
  },
  getters,
  mutations,
  state,
  actions,
  strict: debug,
});
